

function buildUsernameFromEmail(email) {
    return email.replace('@', '.').toLowerCase();
}


module.exports = {
    buildUsernameFromEmail
}